import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FilterFooter } from '../../../elements/filter-footer';
import { DatePicker } from '../../../elements/date-picker';
import { SelectFullname } from '../../../elements/select-fullname';
import { SelectAsync } from '../../../elements/select-async';
import { Input } from '../../../elements/input';
import { Select } from '../../../elements/select';

let obligado = {};
const validacion = Yup.object().shape(obligado);

const initialValues = {
    vehicle: null,
    driver: null,
    timestamp_after: '',
    timestamp_before: ''
};

export const RoutesFilter = ({
    item,
    doFilter,
    close
}: {
    item?: any;
    close: () => void;
    doFilter: (item: any) => void;
}) => {
    const { t } = useTranslation();
    const { api, state, options } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [drivers, setDrivers] = useState<any[]>([]);
    const [areas, setAreas] = useState<any[]>([]);

    useEffect(() => {
        api('/fleet/drivers/', 'GET');
    }, []);

    const beforeSubmit = (values: any | null) => {
        let after = { ...values };

        for (let key in after) {
            if (!after[key]) {
                delete after[key];
            }
        }

        after.vehicle = after.vehicle.id;

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);
        doFilter(enviaremos);
    };

    useEffect(() => {
        if (state.data && state.path.includes('drivers')) {
            if (Array.isArray(state.data.results)) {
                setDrivers(state.data.results);
                api('/fleet/areas/', 'GET');
            }
        }
        if (state.path?.includes('/fleet/areas/') && state.method === 'GET' && state.data) {
            if (Array.isArray(state.data.results)) {
                setAreas(state.data.results);
            }
        }
        if (state.error) {
            toast.error(state.error.detail);
        }
    }, [state]);

    return (
        <div>
            <Formik enableReinitialize={true} initialValues={data || initialValues} validateOnBlur={true} onSubmit={onSubmit}>
                {({ values, errors, touched, setFieldValue, handleSubmit }) => (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <div className="">
                            <DatePicker
                                name="timestamp_after"
                                type="date"
                                label={t('date_time_after')}
                                value={values.timestamp_after}
                                onChange={(value) => {
                                    setFieldValue(
                                        'timestamp_after',
                                        value.timestamp_after ? dayjs(value.timestamp_after).format('YYYY-MM-DD') : null
                                    );
                                }}
                            />
                        </div>
                        <div className="">
                            <DatePicker
                                name="timestamp_before"
                                type="date"
                                label={t('date_time_before')}
                                value={values.timestamp_before}
                                onChange={(value) => {
                                    setFieldValue(
                                        'timestamp_before',
                                        value.timestamp_before ? dayjs(value.timestamp_before).format('YYYY-MM-DD') : null
                                    );
                                }}
                            />
                        </div>
                        <Input
                            label={t('common.label.codigo')}
                            type="code"
                            placeholder={t('common.label.codigo')}
                            name="code"
                            value={values.code}
                            onChange={(value) =>
                                setFieldValue('code', value.code)
                            }
                        />

                        <Select
                            name="area"
                            label={t(
                                'common.label.area'
                            )}
                            placeholder="Select"
                            items={areas}
                            value={
                                data?.area ||
                                values.area
                            }
                            onChange={(value) => {
                                setFieldValue(
                                    'area',
                                    value.area
                                );
                            }}
                        />

                        <SelectFullname
                            name="driver"
                            label={t('common.label.comercial')}
                            placeholder="Select"
                            items={drivers}
                            value={values.driver}
                            onChange={(val) => setFieldValue('driver', val.driver)}
                        />



                        <FilterFooter item={item} doDelete={() => doFilter({})} doSubmit={handleSubmit} close={close} />
                    </form>
                )}
            </Formik>
        </div>
    );
};